import { memo } from "react";
import { Career } from "../../../model/info-about-bootcamp";
import { sanitizeImageUrl } from "../../../utils/sanity.utils";

interface Props {
  data: Career;
}

export const CareerBlock = memo<Props>(({ data }) => {
  return (
    <>
      <div className="pb-50 lg:pb-0">
        <h2
          className="text-center pt-10 lg:pt-20"
          // eslint-disable-next-line
          dangerouslySetInnerHTML={{
            __html: data.title,
          }}
        />
        <div
          // eslint-disable-next-line
          dangerouslySetInnerHTML={{
            __html: data.subtitle,
          }}
          className="m-auto max-w-[900px] p-7 pb-16 lg:pb-25 text-center lg:text-[22px] lg:leading-[27px] text-day-base-base-400"
        />
        <div className="lg:grid grid-cols-3 gap-[10px]">
          {data.list.map((item, index) => (
            <div
              key={index}
              className="mb-6 lg:mb-0 lg:mt-20 flex flex-col rounded-[20px] bg-day-base-base-100 p-8 lg:p-16"
            >
              <div className="grow">
                <img
                  src={item.image && sanitizeImageUrl(item.image?.asset?._ref)}
                  alt={`${item.title} image`}
                />
              </div>
              <div
                // eslint-disable-next-line
                dangerouslySetInnerHTML={{
                  __html: item.title,
                }}
                className="pt-12 pb-4 text-[28px] leading-[30px]"
              />
              {item.description && (
                <div
                  className="text-day-base-base-400"
                  // eslint-disable-next-line
                  dangerouslySetInnerHTML={{
                    __html: item.description,
                  }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
});
